// src/hooks/useDarkMode.js
import { useEffect, useState } from "react";

const STORAGE_KEY = "theme"; // "dark" | "light"

// Светлая по умолчанию при первом заходе
export default function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "dark") return true;
      if (saved === "light") return false;
      // Нет сохранённого выбора -> включаем светлую
      return false;
    } catch {
      return false;
    }
  });

  // Применяем класс к <html> и сохраняем выбор
  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add("dark");
      try { localStorage.setItem(STORAGE_KEY, "dark"); } catch {}
    } else {
      root.classList.remove("dark");
      try { localStorage.setItem(STORAGE_KEY, "light"); } catch {}
    }

    const themeColor = document.head.querySelector('meta[name="theme-color"]');
    if (themeColor) themeColor.setAttribute("content", isDark ? "#0b0f1a" : "#f9fafb");
  }, [isDark]);

  return [isDark, setIsDark];
}
